module.exports = __webpack_public_path__ + "img/shop01.ba36d321.jpg";